const PRACTICE_BASE_URL = '/api/practice';

function getAuthToken() {
  return localStorage.getItem('firebaseToken') || '';
}

async function practiceFetch(url, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {})
  };

  const token = getAuthToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    const error = new Error(payload?.message || 'Request failed');
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
}

export async function fetchPracticeCode(params = {}) {
  const query = new URLSearchParams(params);
  return practiceFetch(`${PRACTICE_BASE_URL}/code?${query.toString()}`);
}

export async function fetchPracticeCodeById(id) {
  return practiceFetch(`${PRACTICE_BASE_URL}/code/${encodeURIComponent(id)}`);
}

export async function fetchRandomPracticeCode(params = {}) {
  const query = new URLSearchParams(params);
  return practiceFetch(`${PRACTICE_BASE_URL}/code/random?${query.toString()}`);
}

export async function fetchPracticeParagraphs(params = {}) {
  const query = new URLSearchParams(params);
  return practiceFetch(`${PRACTICE_BASE_URL}/paragraphs?${query.toString()}`);
}

export async function fetchPracticeParagraphById(id) {
  return practiceFetch(`${PRACTICE_BASE_URL}/paragraphs/${encodeURIComponent(id)}`);
}

export async function fetchRandomPracticeParagraph(params = {}) {
  const query = new URLSearchParams(params);
  return practiceFetch(`${PRACTICE_BASE_URL}/paragraphs/random?${query.toString()}`);
}

export async function fetchRandomPracticeChallenge(params = {}) {
  const query = new URLSearchParams(params);
  return practiceFetch(`${PRACTICE_BASE_URL}/random?${query.toString()}`);
}

export async function fetchDailyChallenge() {
  return practiceFetch(`${PRACTICE_BASE_URL}/daily-challenge`);
}

export async function fetchPracticeLeaderboard(period = 'daily', filters = {}) {
  const query = new URLSearchParams({ period, ...filters });
  return practiceFetch(`${PRACTICE_BASE_URL}/leaderboard?${query.toString()}`);
}

export async function fetchPracticeSummary() {
  return practiceFetch('/api/practice/me/summary');
}

export async function submitPracticeSession(payload) {
  return practiceFetch(`${PRACTICE_BASE_URL}/submit`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export async function savePracticeProgress(payload) {
  return practiceFetch(`${PRACTICE_BASE_URL}/save-progress`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export async function participateInLeaderboard(payload) {
  return practiceFetch(`${PRACTICE_BASE_URL}/leaderboard/participate`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}
